var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row mb-5rem"},[_c('div',{staticClass:"rb-alert rounded-bottom pr-2 px-md-3 d-flex align-items-center position-absolute",class:_vm.variant},[_c('i',{class:_vm.iconClass}),_c('p',{staticClass:"font-weight-normal my-auto ml-3"},[_vm._v(" "+_vm._s(_vm.message)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }